import { Box } from '@wix/design-system';
import { Dismiss as DismissIcon } from '@wix/wix-ui-icons-common';
import classNames from 'classnames';

import { DATA_HOOKS } from '../../dataHooks';

import css from './index.module.scss';


type ArticleRightSideBarProps = {
  showRightSideBar: boolean;
  setShowRightSideBar: (showRightSideBar: boolean) => void;
};

export const ArticleRightSideBar = ({ showRightSideBar, setShowRightSideBar }: ArticleRightSideBarProps) => (
  (
    <Box
      className={
        classNames(css.wrapper,
          { [css.showRightSideBar]: showRightSideBar, [css.hideRightSideBar]: !showRightSideBar }
        )
      }
      direction="vertical"
    >
      <DismissIcon
        className={css.dismissIcon}
        data-hook={DATA_HOOKS.ARTICLE_RIGHT_SIDEBAR_DISMISS_BUTTON}
        onClick={() => setShowRightSideBar(false)} />
    </Box >
  )
);
